import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '../../aura';
import { FormContextData, useFormContext } from '../../state';
import { useValidation } from './helpers/use-validation';
import { useFormErrors } from './helpers/use-form-errors';

const MAX_LENGTH = 40;

export function City(): JSX.Element {
  const { t } = useTranslation('input', { keyPrefix: 'city' });
  const {
    data: { address },
    setData,
  } = useFormContext();
  const { props: formErrorsProps, clear } = useFormErrors('address', true);

  const hasValue = useCallback(
    (data: FormContextData) => (data.address.city ? null : 'City is empty'),
    [],
  );
  const validate = useCallback((data: FormContextData) => {
    if (!data.address.city) {
      return 'City is empty';
    }
    if (data.address.city.length > MAX_LENGTH) {
      return 'Address.City is too long';
    }
    return null;
  }, []);
  const extraInputProps = useValidation(t, hasValue, validate);

  const onValueChange = useCallback(
    (value: string) => {
      clear();
      setData(current => ({
        ...current,
        address: { ...current.address, city: value },
      }));
    },
    [setData, clear],
  );

  return (
    <Input
      id="city"
      type="text"
      label={t('label')}
      value={address.city}
      onValueChange={onValueChange}
      autoComplete="address-level2"
      maxLength={MAX_LENGTH}
      {...extraInputProps}
      {...formErrorsProps}
    />
  );
}
